export default "__VITE_ASSET__D0ii4r7j__"